export const AG_BODY_VIEWPORT = "ag-body-viewport";
export const SCROLLABLE_TABLE_LOADING = "scrollable-table-loading";
export const ROW_SEQUENCE_IS_CHANGING = "row-sequence-is-changing";
export const TABLE = "table";
export const thisCellIsFull = "thisIsFullCellId";
